import axios from "axios";

let API_SERVER = "";
if (process.env.NODE_ENV === "development") {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-catapult.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-catapult.php";
}

function post(action, data = {}) {
  return axios.post(API_SERVER, { action, ...data });
}

export const catapultService = {
  // Settings
  getSettings(clubId) {
    return post("getSettings", { clubId });
  },

  updateSettings(clubId, settings) {
    return post("updateSettings", { clubId, ...settings });
  },

  getWebhookUrl(clubId) {
    return post("getWebhookUrl", { clubId });
  },

  // Athletes
  getAthletes(clubId) {
    return post("listAthletes", { clubId });
  },

  getAthlete(clubId, id) {
    return post("getAthlete", { clubId, athleteId: id });
  },

  createAthlete(clubId, data) {
    return post("createAthlete", { clubId, ...data });
  },

  linkAthleteToPlayer(clubId, athleteId, playerId) {
    return post("linkAthlete", { clubId, athleteId, player_id: playerId });
  },

  getAthleteStats(clubId, id, params = {}) {
    return post("getAthleteStats", { clubId, athleteId: id, ...params });
  },

  getAthleteHistory(clubId, id, params = {}) {
    return post("getAthleteHistory", { clubId, athleteId: id, ...params });
  },

  getAthleteGpsSummary(clubId, id, params = {}) {
    return post("getAthleteGpsSummary", { clubId, athleteId: id, ...params });
  },

  // Activities
  getActivities(clubId, params = {}) {
    return post("listActivities", { clubId, ...params });
  },

  getActivity(clubId, id) {
    return post("getActivity", { clubId, activityId: id });
  },

  getActivityDetail(clubId, activityId) {
    return post("getActivityDetail", { clubId, activityId });
  },

  createActivity(clubId, data) {
    return post("createActivity", { clubId, ...data });
  },

  importStats(clubId, activityId, stats) {
    return post("importStats", { clubId, activityId, stats });
  },

  // Aggregations
  getTeamSummary(clubId, params = {}) {
    return post("getTeamSummary", { clubId, ...params });
  },

  getRankings(clubId, metric, params = {}) {
    return post("getRankings", { clubId, metric, ...params });
  },

  // Webhooks
  getPendingWebhooks(clubId) {
    return post("listPendingWebhooks", { clubId });
  },

  retryWebhook(clubId, id) {
    return post("retryWebhook", { clubId, webhookId: id });
  },

  // Sync from Catapult Connect API
  syncFromApi(clubId, params = {}) {
    return post("syncFromApi", { clubId, ...params });
  },

  // CSV Import
  importCsv(clubId, csvData, options = {}) {
    return post("importCsv", {
      clubId,
      csvData,
      activityName: options.activityName || null,
      activityType: options.activityType || "training",
      activityDate: options.activityDate || null,
      autoCreateAthletes: options.autoCreateAthletes !== false,
    });
  },

  // Scraper
  scraperLogin(clubId, credentials = {}) {
    return post("scraperLogin", { clubId, ...credentials });
  },

  scraperStatus(clubId) {
    return post("scraperStatus", { clubId });
  },

  scraperSync(clubId, params = {}) {
    return post("scraperSync", { clubId, ...params });
  },
};

export default catapultService;
